export default __webpack_public_path__ + "static/media/admin-axomo-header.6dddf765.jpg";